import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { z } from 'zod'
import { authenticatedRoute } from './_authenticated'
import { Box } from '@chakra-ui/react'

const SearchPage = lazy(() => import('@/pages/search'))

function SearchPageWrapper() {
  return (
    <Suspense fallback={<Box minH="100vh" />}>
      <SearchPage />
    </Suspense>
  )
}

// D61 Phase 6 — `focus=search` arrives from the retired /quick-search
// redirect (and from Menu's "Search" row) so Search.tsx can
// auto-focus the unified search box on landing.
const searchSearchSchema = z.object({
  focus: z.literal('search').optional(),
})

export const searchRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/search',
  validateSearch: searchSearchSchema,
  component: SearchPageWrapper,
})
